import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type VesselEquipmentDetailsRequest = CommonTableRequest;

export interface VesselEqType {
    id: number;
    name: string | null;
    shortCode: string | null;
}

export interface VesselEquipmentDetail {
    id: number;
    vesselEquipmentTypeId: number;
    vesselEquipmentMakerId: number;
    vesselEquipmentMakerNameFull: string | null;
    vesselEquipmentTypeName: string | null;
    vesselEquipmentTypeShortCode: string | null;
    vesselEquipmentMakerNameShort: string | null;
    model: string | null;
    filterText: string | null;
    isActive: boolean;
    isBuiltIn: boolean;
    createdUTC: string | null;
    updatedUTC: string | null;
    createdAtUTC: string | null;
}

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface VesselEquipmentDetailsResponse {
    data: VesselEquipmentDetail[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface CreateVesselEquipmentDetailsRequest {
    vesselEquipmentTypeId: number;
    vesselEquipmentMakerId: number;
    model: string;
    filterText: string;
}

export interface VesselEquipmentTypesResponse {
    data: VesselEqType[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export type UpdateVesselEquipmentDetailsRequest = CreateVesselEquipmentDetailsRequest;

export const getApiVesselEquipmentDetails = (
    clientId: number,
    tenantAlias: string,
    payload: VesselEquipmentDetailsRequest,
): Promise<VesselEquipmentDetailsResponse> =>
    httpApi
        .post<VesselEquipmentDetailsResponse>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-equipment-details/search`,
            payload,
        )
        .then(({ data }) => data);

export const createApiVesselEquipmentDetail = (
    clientId: number,
    tenantAlias: string,
    payload: CreateVesselEquipmentDetailsRequest,
): Promise<VesselEquipmentDetail> =>
    httpApi
        .post<VesselEquipmentDetail>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-equipment-details`,
            payload,
        )
        .then(({ data }) => data);

export const updateApiVesselEquipmentDetail = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateVesselEquipmentDetailsRequest,
): Promise<VesselEquipmentDetail> =>
    httpApi
        .put<VesselEquipmentDetail>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-equipment-details/${id}`,
            payload,
        )
        .then(({ data }) => data);

export const getApiVesselEquipmentTypes = (
    clientId: number,
    tenantAlias: string,
    payload: VesselEquipmentDetailsRequest,
): Promise<VesselEquipmentTypesResponse> =>
    httpApi
        .post<VesselEquipmentTypesResponse>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/vessel-equipment-types/search`,
            payload,
        )
        .then(({ data }) => data);
